import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps, SystemStyleObject } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import getElevation, { ElevationSizes } from 'theme/elevations';

const TooltipTheme: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps): SystemStyleObject => ({
    backgroundColor: mode('black.base', 'black.lightest')(props),
    color: 'silver.light',
    borderRadius: '6px',
    boxShadow: getElevation(props, ElevationSizes.sm, 'darkSurface'),
    fontWeight: 'md',
    textAlign: 'center',
    alignItems: 'center',
    maxWidth: '256px',
    padding: '8px 12px',
    size: 'sm'
  })
};

export default TooltipTheme;
